import gsap from 'gsap'
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export let lenis, lenisStop, lenisStart, scrollToStart, initParallax

export const initLenis = () => {

  lenis = new Lenis({
    lerp: 0.1,
    smooth: true,
    direction: 'vertical',
		anchors: {
			offset: -118,
			duration: 1.8
		}
  })

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)

		if (lenis.scroll > 5) {
      document.documentElement.dataset.scrolled = true
    } else {
      document.documentElement.dataset.scrolled = false
    }
	}

	scrollTo()
	requestAnimationFrame(raf)

	lenis.on('scroll', ScrollTrigger.update())

	gsap.ticker.add((time)=>{
		lenis.raf(time * 1000)
	})
	
	gsap.ticker.lagSmoothing(0)

	lenisStop = () => {
		lenis.stop()
	}
	
	lenisStart = () => {
		lenis.start()
	}
}


export const scrollTo = () => {
	const links = document.querySelectorAll('[data-scroll-to]')

	if (!links) return

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			const target = link.getAttribute('data-scroll-to')
			const offset = link.getAttribute('data-scroll-offset')
			const targetEl = document.querySelector(target)
			lenis.scrollTo(targetEl, {
				duration: 1.5,
				offset: offset ? Number(offset) : 0,
				easing: (x) => {
					return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
				}
			})
		})
	})
}

scrollToStart = () => {
  lenis.scrollTo(0, { immediate: true })
}

initParallax = (container) => {

	const elementsToParallax = container.querySelectorAll('[data-parallax]')
  const topElementsToParallax = container.querySelectorAll('[data-parallax-top]')

	if (elementsToParallax.length) {
		elementsToParallax.forEach(element => {
			gsap.fromTo(element, {
				y: '-10%',
				scale: 1.1,
			}, {
				y: '10%',
				scale: 1.1,
				ease: 'none',
				scrollTrigger: {
					trigger: element,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true
				}
			})
		})
	}

	if (topElementsToParallax.length) {
    gsap.to(topElementsToParallax, {
      y: (i, el) => (1 - parseFloat(el.getAttribute('data-parallax-top'))) * ScrollTrigger.maxScroll(window) ,
      ease: 'none',
      scrollTrigger: {
        start: 0,
        end: 'max',
        invalidateOnRefresh: true,
        scrub: true
      }
    })
  }
}

export default () => {}